import { Route, Routes, useLocation } from "react-router-dom";
import "../styles/App.css";
import ProductModal from "../features/inventory/pages/ProductModal";
import Orders from "../features/orders/pages/Orders";
import Inventory from "../features/inventory/pages/Inventory";
import AddProducts from "../features/inventory/pages/AddProducts";
import Support from "../features/support/pages/Support";
import Settings from "../features/settings/pages/Settings";
import History from "../features/orders/pages/History";
import CreateAccount from "../features/auth/pages/CreateAccount";
import ProgressStepDocuments from "../features/auth/components/ProgressStepDocuments";
import VerifiyPasswordReset from "../features/auth/pages/VerifyPassword";
import Dashboard from "../features/dashboard/pages/Dashboard";
import AccountSetup from "../features/auth/pages/AccountSetup";
import ViewCollection from "../features/inventory/pages/ViewCollection";
import OrderModal from "../features/orders/pages/OrderModal";
import { trackPageView } from "../utils/analytics";
import { useEffect } from "react";
import VerifyOtp from "../features/auth/components/VerifyOtp";
import CheckoutReturn from "../features/auth/components/CheckoutReturn";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.breadcrumbsIntegration(),
    Sentry.captureConsoleIntegration(),
  ],
});

function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <div className="App">
        <Routes>
          <Route path="/" element={<CreateAccount />} />
          <Route path="/register/account-setup" element={<AccountSetup />} />
          <Route path="/manager/dashboard" element={<Dashboard />} />
          <Route path="/manager/history" element={<History />} />
          <Route path="/manager/orders" element={<Orders />} />
          <Route path="/manager/orders/:orderNumber" element={<OrderModal />} />
          <Route path="/manager/inventory" element={<Inventory />} />
          <Route
            path="/manager/inventory/:productModal"
            element={<ProductModal />}
          />
          <Route
            path="/manager/inventory/add-new-product"
            element={<AddProducts />}
          />
          <Route path="/manager/support" element={<Support />} />
          <Route path="/manager/settings" element={<Settings />} />
          <Route path="/collection/:title" element={<ViewCollection />} />
          <Route
            path="/register/account-setup/await-review"
            element={<ProgressStepDocuments />}
          />

          <Route path="/verification" element={<VerifyOtp />} />
          <Route
            path="/reset-password/:token"
            element={<VerifiyPasswordReset />}
          />
          <Route path="/checkout/return" element={<CheckoutReturn />} />
        </Routes>
      </div>
    </Sentry.ErrorBoundary>
  );
}

function ErrorFallback() {
  return (
    <div>
      <h2>Something went wrong.</h2>
      <p>Please refresh or try again later.</p>
    </div>
  );
}
export default App;
